import type { StockMediaItem, StockMediaLayerKind } from './types';

const PROVIDER_LABELS: Record<string, string> = {
  pexels: 'Pexels',
};

export function stockProviderLabel(provider: string): string {
  return PROVIDER_LABELS[provider] ?? provider.charAt(0).toUpperCase() + provider.slice(1);
}

export interface StockLayerInput {
  kind: StockMediaLayerKind;
  /** Layer name — doubles as visible attribution in the timeline lane. */
  name: string;
  url: string;
  /** width/height from the API; null when dimensions are unusable. */
  mediaAspect: number | null;
  /** Seconds; null for images, defaulted for videos missing a duration. */
  mediaDuration: number | null;
}

export function stockItemToLayerInput(item: StockMediaItem): StockLayerInput {
  const label = stockProviderLabel(item.provider);
  return {
    kind: item.kind,
    name: item.display_name || (item.author ? `${item.author} · ${label}` : label),
    url: item.file_url,
    mediaAspect: item.width > 0 && item.height > 0 ? item.width / item.height : null,
    mediaDuration: item.kind === 'video' ? item.duration || 5 : null,
  };
}
